export { default as default } from './TornaDalt';
